module.exports = __webpack_public_path__ + "static/media/schrank_mit_flasche_ohne_etiket.7752e7b8.jpg";